import {RegisterRoutesOptions} from '@/moduleSystem';

export const ROUTES__CORE = {
  HOME: 'routes__core__home',
} as const;
export type ROUTES__CORE = Enum<typeof ROUTES__CORE>

export default [
  {
    name: ROUTES__CORE.HOME,
    path: '/',
    component: () => import('./pages/HomePage.vue'),
  },
] as RegisterRoutesOptions;
